import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { AccountCompletion } from '../../interfaces/account-completion';
import * as AccountCompletionActions from './account-completion.actions';

export const accountCompletionFeatureKey = 'accountCompletion';

export interface State {
  accountCompletion: AccountCompletion | null;
  loading: boolean;
  skipping: boolean;
  error: unknown;
}

export const initialState: State = {
  accountCompletion: null,
  loading: false,
  skipping: false,
  error: null,
};

export const accountCompletionReducer = createReducer(
  initialState,
  on(AccountCompletionActions.loadAccountCompletion, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AccountCompletionActions.loadAccountCompletionSuccess, (state, action) => ({
    ...state,
    accountCompletion: action.accountCompletion,
    loading: false,
  })),
  on(AccountCompletionActions.loadAccountCompletionFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
  on(AccountCompletionActions.skipAccountCompletion, (state) => ({
    ...state,
    skipping: true,
    error: null,
  })),
  on(AccountCompletionActions.skipAccountCompletionSuccess, (state, action) => ({
    ...state,
    accountCompletion: action.accountCompletion,
    skipping: false,
  })),
  on(AccountCompletionActions.skipAccountCompletionFailure, (state, action) => ({
    ...state,
    skipping: false,
    error: action.error,
  })),
  on(AccountCompletionActions.clearAccountCompletion, () => initialState)
);

export const selectAccountCompletionState = createFeatureSelector<State>(
  accountCompletionFeatureKey
);

export const selectAccountCompletion = createSelector(
  selectAccountCompletionState,
  (state) => state.accountCompletion
);

export const selectAccountCompletionLoading = createSelector(
  selectAccountCompletionState,
  (state) => state.loading
);

export const selectAccountCompletionSkipping = createSelector(
  selectAccountCompletionState,
  (state) => state.skipping
);

export const selectAccountCompletionVisible = createSelector(
  selectAccountCompletion,
  (accountCompletion) => accountCompletion?.eligible ?? false
);
